import React, { useCallback, useRef, useState } from 'react';
import { IconButton } from '@pypestream/design-system';

import { useCsvUploadModal } from '../modals';

interface CsvUploaderProps {
  onData: (rows: Record<string, string>[], cb: () => void) => void;
}

export const CsvUploader: React.FC<CsvUploaderProps> = ({ onData }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | null>(null);
  const { openModal, modal } = useCsvUploadModal({
    file,
    onUpload: onData,
    onClose: () => {
      resetFile();
      resetInput();
    },
  });

  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const uploadedFile = e.target.files?.[0];
      if (!uploadedFile) return;

      if (!uploadedFile.name.toLowerCase().endsWith('.csv')) {
        console.error('Please upload a valid CSV file.');
        return;
      }

      setFile(uploadedFile);
      openModal();
    },
    [openModal]
  );

  const resetInput = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  }, []);

  const resetFile = useCallback(() => {
    setFile(null);
  }, []);

  return (
    <>
      <input
        type="file"
        accept=".csv"
        ref={inputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />

      <IconButton size="small" name="upload" onClick={handleButtonClick} />
      {modal}
    </>
  );
};
